//General application state

import { ChangeRequestDataStructureType } from '@/tsEnums/changeRequestDataStructureType';
import type { Resource, GroupCharacteristic } from 'fhir/r4';
import { defineStore } from 'pinia';

export const useGeneralStore = defineStore('generalStore', {
  state: () => {
    return {
      genericInfoModal: {
        header: '',
        message: '',
      },
      mainTitle: 'Trial Management System' as string,
      fontSize: '1rem',
      entriesPerPage: 15, //Entries per page in study list
      createSubstanceContext: null as null | {
        index: number;
        element: GroupCharacteristic;
        list: Array<GroupCharacteristic>;
      },

      //Used for displaying only viable options in the selection for identifier systems
      unusedIdentifierSystems: [] as Array<{
        code: string;
        display?: string;
        system?: string;
      }>,

      //Temporary id for marking new resources
      temporaryId: 'tmpResIdForTransaction',

      //State regarding change request modal
      changeRequestBaseResourceRef: undefined as string | undefined,
      changeRequestModalFhirPath: undefined as string | undefined,
      changeRequestModalSubject: undefined as string | Resource | undefined,
      changeRequestModalDataStructureType: undefined as
        | ChangeRequestDataStructureType
        | undefined,
      showChangeRequestModal: false,
      changeRequestSelectionOptions: [] as Array<object>, //Array with options for selecting new values, usually CodeSystem or ValueSet.
      changeRequestProposeAdditionalEntry: false as boolean,
      changeRequestcharacteristicCode: '' as string, //Only used for changes to characteristic
      changeRequestcharacteristicCodeSystem: '' as string, //Only used for changes to characteristic
      changeRequestcharacteristicValueSystem: '' as string, //Only used for changes to characteristic
      changeRequestcharacteristicCodeDisplay: '' as string, //Only used for changes to characteristic
      processingChangeRequest: false,

      //State regarding modal for creating new Locations
      locationCreationLoading: false as boolean,
      locationCreationModalCloseAfterSave: true as boolean, //Is used to enable expected behaviour when trying to create a Location that is similar to an existing one (alternativeModalView = true)
      showLocCreateModal: false as boolean,
      showPwaInstallPrompt: false, //Signals wheter to show prompt for installing pwa

      //Properties for generic text input modal
      genericTextInputModal: {
        header: '',
        message: '',
        placeholder: '',
      },
    };
  },
  getters: {},
});
